<div
  *ngIf="isLoading"
  
>
  <app-busy [message]="message"></app-busy>
</div>

<div class="page_header">
    <h1 class="heading">Select Applications</h1>
  </div>
<div style="float:right;margin: 5px;">
    <button type="button" class="btn btn-primary" (click)="returnSelectApplication()" *ngIf="this.all_selected_values.length > 0">Return selected</button>
    <button type="button" class="btn btn-primary" (click)="returnSelectApplication()" *ngIf="this.all_selected_values.length == 0">Back</button>

  </div>
<table class="table custom_table" cellspacing="0" width="100%">
    <thead>
        <tr>
            <th>Select</th>
            <th>App</th>
            <th>Account Number</th>
            <th>Name</th>
            <th>Type</th>
            <th>Num Vehicles</th>
            <th>Submitted on</th>
            <th>Status</th>
            <th>Open</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let a of apps">
            <td>
                <input
                    type="checkbox"
                    (change)="onChange(a)"
                    value="{{ a }}"
                  />
            </td>
            <td>{{a.AccountNumber}}</td>
            <td>{{a.ApplicationNumber}}</td>
            <td>{{a.Name}}</td>
            <td>{{a.PermitType}}</td>
            <td>{{a.vehicles.length}}</td>
            <td >
                {{a.submission_date | date:'dd MM yyyy'}}
            </td>
            <td >
                {{a.Status}}
            </td>
            <td class="text-center">
                <i class="fa fa-share-square-o" aria-hidden="true" style="font-size: 25px;color: #1D3F94 ;"></i>
            </td>
        </tr>
    </tbody>
</table>